/*
 * analytics.js — Clube Rock 2026 (dono: Pedal, EC-04). Contrato: docs/analytics-contrato.md.
 * Porta do pixel Solomon/Meta validado no Lote 5 (paridade, Setlist 2026-10-14) + dataLayer GA4 (cro-e-medicao §4.3).
 * Paridade: nomes de evento, parâmetros, formato do eventID e envelope do CAPI iguais ao publicado.
 * CORRIGIR_PAYLOAD só muda com aceite da Solomon/Henrique (D-P1 / Q4).
 */
const PIXELS = ['1475934013026318'];
const COMPANY_ID = '87H9VEXDLuglxl4A8XhO';
const CAPI_URL = 'https://pixel-events-fqxpwg3smq-ue.a.run.app/event';
const IS_TEST = false;
const FB_INDEX = '2';
const FB_DOMAIN = '.cluberock.com.br';
const CORRIGIR_PAYLOAD = false;
// L11b (AUD-AC): sem `form.ymp-CrtpageMainFrm button[type="button"]`, que após o L11a casava −, + e Continuar no /cart;
// o clone da Yampi é type=submit e casa por .ymp_check_mainBtn/.cart__checkout-button.
const CHECKOUT_SEL = '.ymp_mainBtn,.ymp_check_mainBtn,.cartx_check_mainBtn,.cart__checkout-button';

const ctx = (() => {
  try { return JSON.parse(document.getElementById('cr-analytics-ctx').textContent); } catch (e) { return {}; }
})();
const ls = {
  get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
  set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
};

/* ---------- trava de envio (decisão JARVIS + condições do Setlist, 2026-10-15; L6f) ----------
 * Fonte: window.CR.trava, calculada pelo snippet inline analytics-trava no <head> (antes do GTM).
 * Se o snippet não estiver na página, as MESMAS regras são aplicadas aqui:
 *  - prévia = Shopify.theme.role exatamente 'unpublished' ou 'development', ou Shopify.designMode, ou preview_theme_id
 *    na URL (a Shopify tira esse parâmetro com um 302, por isso ele não basta); papel 'main' ou vazio = produção;
 *  - no publicado, chave e código de teste são apagados da sessão; webdriver bloqueia sempre;
 *  - chave só na prévia: ?cr_pixel=1 ou setting analytics_em_previa; ?cr_pixel=0 apaga e vence cr_test;
 *  - com chave, na prévia, ?cr_test=<código> vai como test_event_code no CAPI (Eventos de Teste do Meta).
 * Visitante real do tema publicado nunca cai na trava. O dataLayer continua. Estado em CR.analytics.envio.
 */
const ENVIO = (() => {
  if (window.CR && window.CR.trava && typeof window.CR.trava.ativo === 'boolean') return window.CR.trava;
  const sh = window.Shopify || {};
  const papel = sh.theme && sh.theme.role;
  const q = new URLSearchParams(location.search);
  const lg = (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
  const gr = (k, v) => { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} };
  const p = q.get('cr_pixel'), t = q.get('cr_test');
  const previa = papel === 'unpublished' || papel === 'development' || q.has('preview_theme_id') || !!sh.designMode;
  let chave = false, teste = null;
  gr('cr_previa', null);
  if (!previa || p === '0') { gr('cr_pixel', null); gr('cr_test', null); }
  else {
    if (p === '1') { gr('cr_pixel', '1'); chave = true; }
    if (t && /^[A-Za-z0-9_-]{1,40}$/.test(t)) { gr('cr_test', t); teste = t; }
    chave = chave || lg('cr_pixel') === '1';
    teste = teste || lg('cr_test');
  }
  chave = chave || ctx.analyticsEmPrevia === true;
  if (navigator.webdriver === true) return { ativo: false, motivo: 'automatizado', teste: null };
  if (previa && !chave) return { ativo: false, motivo: 'previa', teste: null };
  return { ativo: true, motivo: previa ? 'previa_com_chave' : 'producao', teste: previa ? (teste || null) : null };
})();
if (!ENVIO.ativo) { try { console.info('[CR analytics] pixel e CAPI desligados: ' + ENVIO.motivo); } catch (e) {} }

/* ---------- cookies / ids (iguais ao legado) ---------- */
function getCookie(name) {
  const hit = document.cookie.split(';').map((c) => c.trim()).find((c) => c.startsWith(name + '='));
  if (!hit) return null;
  const v = decodeURIComponent(hit.substring(name.length + 1));
  if (name === '_fbc') {
    // legado: idade em dias com o timestamp (ms) tratado como segundos; mantido igual por paridade
    const p = v.split('.');
    if (p.length >= 3 && (Date.now() - new Date(parseInt(p[2], 10) * 1000)) / 864e5 >= 89) return null;
  }
  return v;
}
function baseDomain(host) {
  const dbl = ['.co.uk', '.com.br', '.myshopify.com'];
  const n = dbl.some((t) => host.endsWith(t)) ? 3 : 2;
  const parts = host.split('.');
  return parts.length <= n ? '.' + host : '.' + parts.slice(1).join('.');
}
function setCookie(name, value, days, domain) {
  if (!domain || !location.hostname.includes(domain.replace(/^\./, ''))) domain = baseDomain(location.hostname);
  const exp = days ? '; expires=' + new Date(Date.now() + days * 864e5).toUTCString() : '';
  document.cookie = name + '=' + (value || '') + exp + '; path=/; SameSite=Lax; domain=' + domain;
}
const uniqueId = ls.get('uniqueId') || getCookie('uniqueId') || (() => {
  const id = Math.random().toString(36).substr(2, 9) + '_' + Date.now();
  ls.set('uniqueId', id); setCookie('uniqueId', id, 365, FB_DOMAIN);
  return id;
})();
let fbp = getCookie('_fbp');
if (!fbp) { fbp = `fb.${FB_INDEX}.${Date.now()}.${Math.floor(1e8 + 9e8 * Math.random())}`; setCookie('_fbp', fbp, 730, FB_DOMAIN); }
let fbc = getCookie('_fbc');
const fbclid = new URLSearchParams(location.search).get('fbclid');
if (fbclid) { fbc = `fb.${FB_INDEX}.${Date.now()}.${fbclid}`; setCookie('_fbc', fbc, 89, FB_DOMAIN); }

export function eventId(nome) { return `${nome}_${Date.now()}_${Math.floor(Math.random() * 1000000)}`; }

/* ---------- IP (ipify): mantido por paridade (decisão JARVIS 14/10), só após o load, nunca bloqueando ----------
 * L6a-7: prazo real por tentativa (AbortController, 2 s) e limite total de 4 s contado a partir do load;
 * api6 travada não impede o fallback api64. O InitiateCheckout não espera o IP.
 */
let ip = null;
async function buscarIp(u, ms) {
  const c = new AbortController();
  const t = setTimeout(() => c.abort(), ms);
  try { const r = await fetch(u, { signal: c.signal }); return (await r.json()).ip || null; } catch (e) { return null; } finally { clearTimeout(t); }
}
const ipPromise = new Promise((resolve) => {
  const go = async () => {
    if (!ENVIO.ativo) return resolve();
    const fim = Date.now() + 4000;
    for (const u of ['https://api6.ipify.org?format=json', 'https://api64.ipify.org?format=json']) {
      const resta = fim - Date.now();
      if (resta <= 0) break;
      ip = await buscarIp(u, Math.min(2000, resta));
      if (ip) break;
    }
    resolve();
  };
  if (document.readyState === 'complete') go(); else addEventListener('load', go, { once: true });
});

/* ---------- usuário: só HASH no navegador (decisão JARVIS 2026-10-14, pendência 3) ----------
 * O legado guardava e-mail/telefone/nome EM CLARO em localStorage('SolomonUser'). Aqui:
 *  - normaliza e aplica SHA-256 na hora da digitação; guarda só {em, ph, fn, ln} em 'cr_user_hash';
 *  - migra um 'SolomonUser' antigo (hash + apaga o valor em claro);
 *  - cookies solomon_* (do app Solomon) são só lidos e hasheados em memória, nunca regravados.
 * Se a Solomon exigir o valor em claro, o setting 'solomon_user_em_claro' (padrão false, ctx.solomonEmClaro)
 * reativa a gravação legada. Documentado em docs/LEIAME-pedal.md.
 */
const norm = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-zA-Z]/g, '').toLowerCase().trim();
const num = (s) => s.replace(/[^0-9]/g, '').trim();
async function sha256(m) {
  const b = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(m));
  return Array.from(new Uint8Array(b)).map((x) => x.toString(16).padStart(2, '0')).join('');
}
const HASH_KEY = 'cr_user_hash';
const EM_CLARO = ctx.solomonEmClaro === true;
const lerHash = () => { try { return JSON.parse(ls.get(HASH_KEY)) || {}; } catch (e) { return {}; } };
const gravarHash = (h) => ls.set(HASH_KEY, JSON.stringify(h));
async function hashCampos(u) {
  const h = {};
  if (u.email) h.em = await sha256(u.email.toLowerCase().trim());
  if (u.phone) h.ph = await sha256(num(u.phone));
  if (u.firstName) h.fn = await sha256(norm(u.firstName));
  if (u.lastName) h.ln = await sha256(norm(u.lastName));
  if (u.city) h.ct = await sha256(norm(u.city));
  if (u.state) h.st = await sha256(norm(u.state));
  if (u.zip) h.zp = await sha256(num(u.zip));
  if (u.country) h.country = await sha256(norm(u.country));
  return h;
}
const userPronto = (async () => {
  let h = lerHash();
  // L6a-4: o valor em claro sai do aparelho ANTES de qualquer conversão, falhe ela ou não (JSON inválido, tipos estranhos, crypto indisponível)
  let antigo = null;
  try { antigo = JSON.parse(ls.get('SolomonUser')); } catch (e) {}
  if (!EM_CLARO) { try { localStorage.removeItem('SolomonUser'); } catch (e) {} }
  const soTexto = (o) => Object.fromEntries(Object.entries(o).filter(([, v]) => typeof v === 'string'));
  if (antigo && typeof antigo === 'object' && !Array.isArray(antigo)) {
    try { h = { ...(await hashCampos(soTexto(antigo))), ...h }; gravarHash({ em: h.em, ph: h.ph, fn: h.fn, ln: h.ln }); } catch (e) {}
  }
  try {
    const c = {};
    document.cookie.split(';').forEach((k) => {
      const [a, v] = k.split('=').map((x) => x.trim());
      if (a && a.startsWith('solomon_')) c[a.substring(8)] = decodeURIComponent(v || '');
    });
    if (Object.keys(c).length) h = { ...h, ...(await hashCampos(c)) }; // legado: cookies têm prioridade (só em memória)
  } catch (e) {}
  return h;
})();
let userHash = {};
userPronto.then((h) => { userHash = h; }).catch(() => {});
const hashUser = async () => { await userPronto.catch(() => {}); return userHash; };

const RELEVANTE = (i) => /email|phone|name/i.test(i.id) || /email|phone|name/i.test(i.name);
function bindInput(i) {
  if (i.__crBound || !RELEVANTE(i)) return;
  i.__crBound = true;
  i.addEventListener('change', async () => {
    const u = {};
    if (/email/i.test(i.id) || /email/i.test(i.name)) {
      if (/^[^@\s]+@[^@\s]+\.[^\s]+$/.test(i.value)) u.email = i.value;
    } else if (/phone/i.test(i.id) || /phone/i.test(i.name)) {
      if (/^(?:\D*\d){9}\D*$|^(?:\D*\d){11}\D*$|^(?:\D*\d){13}\D*$/.test(i.value)) u.phone = i.value;
    } else {
      const n = i.value.split(' ');
      u.firstName = n[0]; u.lastName = n.length > 1 ? n.slice(1).join(' ') : '';
    }
    if (!Object.keys(u).length) return;
    try {
      const novo = await hashCampos(u);
      if ('lastName' in u && !u.lastName) delete userHash.ln;
      userHash = { ...userHash, ...novo };
      gravarHash({ em: userHash.em, ph: userHash.ph, fn: userHash.fn, ln: userHash.ln });
      if (EM_CLARO) { // chamada legada, desligada por padrão
        let legado = {}; try { legado = JSON.parse(ls.get('SolomonUser')) || {}; } catch (e) {}
        ls.set('SolomonUser', JSON.stringify({ ...legado, ...u }));
      }
    } catch (e) {}
  });
}

/* ---------- fbq (stub legado com o filtro de Purchase) — só com envio ativo ---------- */
(function (f, b, e, v) {
  if (!ENVIO.ativo || f.fbq) return;
  const n = (f.fbq = function () {
    if (arguments[1] === 'Purchase' && (typeof arguments[2].order_id === 'undefined' || !arguments[3] || !arguments[3].eventID || !arguments[3].eventID.startsWith('Purchase'))) return;
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!f._fbq) f._fbq = n;
  n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
  const t = b.createElement(e); t.async = true; t.src = v;
  const s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

/* ---------- envio (pixel + CAPI), mesmo payload do legado ---------- */
const pageviewId = eventId('PageView');
async function enviar(nome, data, id) {
  if (!ENVIO.ativo) return;
  let custom = {};
  const ids = () => (data.items.length === 1 ? data.items[0].item_id.toString() : data.items.map((i) => i.item_id.toString()));
  const contents = () => data.items.map((i) => ({ id: i.item_id.toString(), quantity: i.item_quantity }));
  const ic = nome === 'InitiateCheckout';
  if (nome !== 'PageView') {
    custom = {
      content_ids: ids(),
      content_name: data.items[0].item_name,
      content_type: 'product_group',
      value: ic ? data.total_price : data.items[0].price,
      currency: ic ? data.currency : data.items[0].currency,
      content_category: data.items[0].item_category,
      num_items: ic ? data.items.reduce((t, i) => t + i.item_quantity, 0) : (CORRIGIR_PAYLOAD ? data.items.reduce((t, i) => t + i.item_quantity, 0) : 0),
      contents: contents()
    };
    if (CORRIGIR_PAYLOAD && !ic) custom.value = Number(custom.value);
  }
  // L6a-5: o InitiateCheckout não espera nada (nem IP nem hash pendente): sai no mesmo tique do clique, antes da navegação à Yampi
  let h = userHash;
  if (!ic) { await ipPromise; h = await hashUser(); }
  if (window.fbq && nome !== 'PageView') {
    const px = { content_ids: custom.content_ids, content_name: custom.content_name, content_type: 'product_group', value: ic ? data.total_price : custom.value, currency: custom.currency, content_category: custom.content_category, contents: custom.contents };
    if (ic) px.num_items = custom.num_items;
    PIXELS.forEach((p) => fbq('trackSingle', p, nome, px, { eventID: id }));
  }
  fetch(CAPI_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    keepalive: true,
    body: JSON.stringify({
      event_name: nome,
      event_time: Math.floor(Date.now() / 1000),
      user_data: { em: h.em, ph: h.ph, fn: h.fn, ln: h.ln, ct: h.ct, st: h.st, zp: h.zp, country: h.country, external_id: uniqueId, client_ip_address: ip, client_user_agent: navigator.userAgent, fbc: getCookie('_fbc') || fbc, fbp: getCookie('_fbp') || fbp || getCookie('fbp') },
      custom_data: custom,
      event_source_url: location.href,
      event_id: id,
      action_source: 'website',
      referrer_url: document.referrer,
      company_id: COMPANY_ID,
      test: IS_TEST,
      ...(ENVIO.teste ? { test_event_code: ENVIO.teste } : {}) // só em prévia com chave e ?cr_test (Setlist)
    })
  }).catch(() => {});
}
function meta(nome, data) { const id = eventId(nome); enviar(nome, data, id).catch(() => {}); return id; }

/* ---------- dataLayer GA4 ---------- */
window.dataLayer = window.dataLayer || [];
// item_id = id do PRODUTO em todo o funil (grade, PDP, carrinho, checkout) e item_variant = SKU (ou o nome da variante, se
// faltar SKU). Decisão do JARVIS de 15/10 (canon do Setlist): antes a grade mandava o produto e PDP/carrinho o SKU, e o GA4
// não ligava view_item_list → view_item → add_to_cart do mesmo item. O Meta (metaPayload) não usa ga4Item: não muda.
const ga4Item = (i, idx) => ({ item_id: String(i.item_id), item_name: i.item_name, item_variant: i.sku || i.item_variant, price: i.price / 100, quantity: i.quantity || 1, ...(idx != null ? { index: idx } : {}) });
const soma = (items) => items.reduce((t, i) => t + (i.price * (i.quantity || 1)), 0) / 100;
export function event(nome, params = {}, ecommerce) {
  if (ecommerce) window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({ event: nome, ...params, ...(ecommerce ? { ecommerce } : {}) });
}
const cartItems = (cart) => (cart.items || []).map((l) => ({ item_id: l.product_id, sku: l.sku, item_name: l.title, item_variant: l.variant_title, price: l.price, quantity: l.quantity }));
const kitN = (cart) => cart.kit_n ?? null; // a seção do drawer (Vinil) informa as camisetas elegíveis
// L8m (AUD-O do Fiscal, achado do Setlist): kit_n do begin_checkout lido da barra [data-cr-trio][data-kit-n] no clique — a do
// drawer quando o botão está nele (ou quando ele está aberto, na porta do wrapper da Yampi), senão a da página (/cart).
// Sem barra legível: null, e quem chama usa o kit_n do carrinho como reserva.
function kitDaBarra(alvo) {
  try {
    const sel = '[data-cr-trio][data-kit-n]';
    const gaveta = (alvo && alvo.closest && alvo.closest('[data-cr-gaveta]')) || document.querySelector('[data-cr-gaveta][open]');
    const b = gaveta ? gaveta.querySelector(sel) : [...document.querySelectorAll(sel)].find((x) => !x.closest('[data-cr-gaveta]'));
    const v = b && b.dataset.kitN;
    return v == null || v === '' || !Number.isFinite(Number(v)) ? null : Number(v);
  } catch (e) { return null; }
}

/* ---------- legado: forma dos itens que o publicado mandava no AddToCart ---------- */
function legadoAtc(items) {
  const p = ctx.produto;
  if (!CORRIGIR_PAYLOAD && p && items.length === 1 && String(items[0].item_id) === String(p.item_id)) return { items: [p] };
  if (!CORRIGIR_PAYLOAD) return { items: items.map((i) => ({ item_id: i.item_id, item_quantity: i.quantity || 1, currency: ctx.moeda })) };
  return { items: items.map((i) => ({ item_id: i.item_id, item_name: i.item_name, price: (i.price / 100).toFixed(2), item_quantity: i.quantity || 1, item_category: i.item_category || '', currency: ctx.moeda })) };
}

/* ---------- API pública (nunca lança; nunca bloqueia carrinho/checkout) ---------- */
// aceita itens do /cart/add.js (product_id, variant_id, title, variant_title, price, quantity, sku) ou do card
const normItem = (i) => ({ item_id: i.product_id ?? i.item_id, sku: i.sku, item_name: i.product_title || i.item_name || i.title, item_variant: i.variant_title ?? i.item_variant, price: i.price, quantity: i.quantity || 1, item_category: i.product_type });
const seguro = (fn) => (...a) => { try { return fn(...a); } catch (e) { return null; } };
let carrinhoAtual = ctx.carrinho || null;
document.addEventListener('cr:cart:updated', (e) => { if (e.detail && e.detail.cart) carrinhoAtual = e.detail.cart; });
export function addToCart(itensBrutos, { origem = 'pdp' } = {}) {
  const items = (Array.isArray(itensBrutos) ? itensBrutos : [itensBrutos]).map(normItem);
  const id = meta('AddToCart', legadoAtc(items));
  event('add_to_cart', { item_list_name: origem, event_id: id }, { currency: ctx.moeda, value: soma(items), items: items.map((i) => ga4Item(i)) });
  return id;
}
export function cartChange(item, delta) {
  if (!delta) return;
  const it = { ...normItem(item), quantity: Math.abs(delta) };
  event(delta > 0 ? 'add_to_cart' : 'remove_from_cart', { item_list_name: 'drawer' }, { currency: ctx.moeda, value: soma([it]), items: [ga4Item(it)] });
}
export function viewCart(cart, { origem = 'drawer' } = {}) {
  // L8m: o carrinho enriquecido do drawer (kit_n, frete_falta_centavos) vira o carrinhoAtual, sem novo cr:cart:updated
  // (o frete.js recota a cada aviso)
  if (cart && Array.isArray(cart.items)) carrinhoAtual = cart;
  event('view_cart', { origem, kit_n: kitN(cart), frete_falta_centavos: cart.frete_falta_centavos ?? null }, { currency: ctx.moeda, value: cart.total_price / 100, items: cartItems(cart).map((i) => ga4Item(i)) });
}
let icEnviado = false;
export function beginCheckout(cart, { alvo } = {}) {
  if (icEnviado) return null;
  const c = cart || carrinhoAtual || {};
  const tem = c.item_count > 0 && Array.isArray(c.items) && c.items.length > 0 && c.items.every((l) => l && l.product_id != null);
  const p = ctx.produto;
  if (!tem && !(p && p.item_id != null)) return null; // L6a-5: tentativa sem itens válidos não consome a trava
  icEnviado = true;
  const id = meta('InitiateCheckout', {
    item_count: tem ? c.item_count : 1,
    items: tem
      ? c.items.map((l) => ({ item_id: l.product_id, item_name: l.title, item_variant: l.variant_title, item_price: l.price, item_quantity: l.quantity, item_brand: l.vendor, item_category: l.product_type }))
      : [{ item_id: p && p.item_id, item_name: p && p.item_name, item_variant: p && p.item_variant, item_price: p && p.price_centavos, item_quantity: 1, item_brand: p && p.item_brand, item_category: p && p.item_category }],
    total_price: tem ? c.total_price / 100 : p && p.price_centavos, // legado: centavos neste ramo (ver validação Lote 5)
    currency: c.currency || ctx.moeda,
    total_discount: tem ? c.total_discount : 0,
    url: location.href,
    referrer: document.referrer
  });
  if (tem) event('begin_checkout', { kit_n: kitDaBarra(alvo) ?? kitN(c), itens_total: c.item_count, event_id: id }, { currency: c.currency, value: c.total_price / 100, items: cartItems(c).map((i) => ga4Item(i)) });
  return id;
}
export function selectItem(item, { lista, index }) {
  event('select_item', { item_list_name: lista }, { item_list_name: lista, items: [ga4Item(normItem(item), index)] });
}

// exp_view (decisão do JARVIS, 15/10; cro-e-medicao.md §5.3, regra 7): o MESMO disparo nos dois braços, num formato só:
// { teste, braco } (+ extras da lista EXP_EXTRAS). Uma vez por teste por página. Gatilhos, iguais para A e B:
// (1) bloco [data-cr-exp="t6"][data-cr-braco="a|b"] que aparece na tela (qualquer parte visível);
// (2) document.dispatchEvent(new CustomEvent('cr:exp', { detail: { teste, braco, ...extras } })) para estados (ex.: T10, n = 2);
// (3) CR.analytics.expView(teste, braco, extras).
const EXP_VISTOS = new Set();
const EXP_ID = /^[a-z0-9_-]{1,20}$/;
// Extras permitidos, por nome e faixa (L6k-1 do Riff: nada de chave livre, que poderia sobrescrever "event" ou levar dado
// pessoal). Novo extra de um teste entra aqui, com a faixa, junto com o teste.
const EXP_EXTRAS = { n: (v) => Number.isInteger(v) && v >= 0 && v <= 99 }; // T10: itens elegíveis no carrinho
export function expView(teste, braco, extras = {}) {
  const t = String(teste || '').trim().toLowerCase(), b = String(braco || '').trim().toLowerCase();
  if (!EXP_ID.test(t) || !EXP_ID.test(b) || EXP_VISTOS.has(t)) return false;
  EXP_VISTOS.add(t);
  const ok = {};
  for (const [k, v] of Object.entries(extras || {})) if (Object.prototype.hasOwnProperty.call(EXP_EXTRAS, k) && EXP_EXTRAS[k](v)) ok[k] = v;
  event('exp_view', { ...ok, teste: t, braco: b }); // só chaves de EXP_EXTRAS chegam aqui: "event" não sobrescreve o envelope
  return true;
}

// view_promotion (L6l; pedido do Setlist, aprovado pelo JARVIS em 15/10): 1 por slide do hero exibido, uma vez por slide
// por página, com promotion_name e creative_slot iguais aos do select_promotion (data-cr-promo/data-cr-slot do botão; o
// clique vai pelo core.js). Slide sem botão não tem clique e também não manda vista. "Exibido" = metade do slide na tela
// (IntersectionObserver; conta o recorte da faixa com rolagem do reduced-motion) E visível no CSS (o carrossel troca por
// animação de opacity/visibility, que o IntersectionObserver não enxerga). Enquanto algum slide estiver na tela, confere a
// cada 500 ms (aba oculta não conta); quando todos foram vistos, para. É amostragem, não tempo mínimo de exposição: um slide
// que fica visível menos de 500 ms pode não contar (o fade dura 0,6 s e cada slide fica "intervalo" segundos).
// L6l-1 (Riff): "metade" pela razão (intersectionRatio ≥ 0,5), não por isIntersecting (que é true com qualquer interseção;
// o threshold só decide quando o callback roda). Ver testes/pedal/l6l-promo.test.mjs.
function promocoes() {
  const slides = [...document.querySelectorAll('.cr-hero__slide')].filter((s) => s.querySelector('[data-cr-promo]'));
  if (!slides.length || !window.IntersectionObserver) return;
  const naTela = new Set();
  let timer = null;
  const parar = () => { clearInterval(timer); timer = null; };
  const conferir = () => {
    if (document.visibilityState === 'hidden') return;
    naTela.forEach((s) => {
      const c = getComputedStyle(s);
      if (s.__crPromo || c.visibility !== 'visible' || +c.opacity < 0.5) return;
      s.__crPromo = true;
      const a = s.querySelector('[data-cr-promo]');
      event('view_promotion', { promotion_name: a.dataset.crPromo, creative_slot: a.dataset.crSlot });
    });
    if (slides.every((s) => s.__crPromo)) { parar(); io.disconnect(); }
  };
  const io = new IntersectionObserver((es) => {
    es.forEach((e) => { if (e.isIntersecting && e.intersectionRatio >= 0.5) naTela.add(e.target); else naTela.delete(e.target); });
    if (naTela.size && !timer) { timer = setInterval(conferir, 500); conferir(); } else if (!naTela.size && timer) parar();
  }, { threshold: 0.5 });
  slides.forEach((s) => io.observe(s));
}

// trio_step (L13a; Setlist, só GA4, sem Meta): o kit-folha.js emite cr:kit:passo {origem, n, k, acao} ao abrir a folha, a
// cada vaga preenchida e no "Ver mais". Só esses 4 parâmetros, cada um na sua faixa (regra do L6k-1: nada de chave livre).
const PASSO_ORIGEM = ['home', 'pdp'], PASSO_ACAO = ['abrir', 'escolher', 'ver_mais'];
const PASSO_N = (v) => Number.isInteger(v) && v >= 0 && v <= 99;
export function trioPasso(d) {
  const { origem, n, k, acao } = d || {};
  if (!PASSO_ORIGEM.includes(origem) || !PASSO_ACAO.includes(acao) || !PASSO_N(n) || !PASSO_N(k)) return false;
  event('trio_step', { origem, n, k, acao });
  return true;
}

// view_item_list das sugestões (L13a; Setlist, co-compra item 1): gaveta e folha do trio (.cr-sugestoes__lista com
// data-cr-lista; a folha é kit_trio). O card conta quando metade dele aparece (IntersectionObserver pela razão, como no
// L6l-1): gaveta ou folha fechada e card oculto (produto já no carrinho) não aparecem, então não contam. Cards novos ("Ver
// mais", gaveta redesenhada) entram pelo MutationObserver do iniciar(). Um envio por lista a cada lote visto em 300 ms, com
// até 12 itens por evento (como a grade); cada produto conta uma vez por lista por página, mesmo com a gaveta redesenhada.
const SUG_SEL = '.cr-sugestoes__lista[data-cr-lista] [data-cr-item]';
function sugestoesVistas() {
  if (!window.IntersectionObserver) return null;
  const vistos = new Set(), fila = new Map();
  let timer = null;
  const soltar = () => {
    timer = null;
    fila.forEach((items, lista) => { for (let i = 0; i < items.length; i += 12) event('view_item_list', { item_list_name: lista }, { item_list_name: lista, items: items.slice(i, i + 12) }); });
    fila.clear();
  };
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting || e.intersectionRatio < 0.5) return;
    io.unobserve(e.target);
    try {
      const lista = e.target.closest('[data-cr-lista]').dataset.crLista, it = JSON.parse(e.target.dataset.crItem), chave = `${lista}:${it.item_id}`;
      if (vistos.has(chave)) return;
      vistos.add(chave);
      if (!fila.has(lista)) fila.set(lista, []);
      fila.get(lista).push(ga4Item(normItem(it), it.index));
      if (!timer) timer = setTimeout(soltar, 300);
    } catch (err) {}
  }), { threshold: 0.5 });
  const vigiar = (el) => { if (!el.__crSug) { el.__crSug = true; io.observe(el); } };
  document.querySelectorAll(SUG_SEL).forEach(vigiar);
  return vigiar;
}

/* ---------- automáticos ---------- */
function iniciar() {
  if (ENVIO.ativo) hashUser().then((h) => {
    PIXELS.forEach((p) => {
      fbq('set', 'autoConfig', 'false', p);
      fbq('init', p, { external_id: uniqueId, em: h.em, ph: h.ph, fn: h.fn, ln: h.ln, ct: h.ct, st: h.st, zp: h.zp, country: h.country });
      fbq('trackSingle', p, 'PageView', {}, { eventID: pageviewId });
    });
    enviar('PageView', { url: location.href, referrer: document.referrer }, pageviewId);
  });

  if (ctx.template === 'product' && ctx.produto) {
    meta('ViewContent', { items: [ctx.produto] });
    event('view_item', {}, { currency: ctx.moeda, value: ctx.produto.ga4.price, items: [ctx.produto.ga4] });
  }
  if (ctx.template === 'search' && ctx.busca) {
    if (ctx.busca.items.length) meta('Search', { items: ctx.busca.items });
    let origem = 'page';
    // L8i: a marca do search.js é {origem, termo}; só vale se o termo for o desta busca (senão é busca pela página)
    try {
      const m = sessionStorage.getItem('cr_busca_origem'); sessionStorage.removeItem('cr_busca_origem');
      const o = m && JSON.parse(m), n = (s) => String(s || '').trim().toLowerCase();
      if (o && o.origem && n(o.termo) === n(ctx.busca.termo)) origem = o.origem;
    } catch (e) {}
    event('search', { search_term: ctx.busca.termo, results_count: ctx.busca.total, origem });
  }

  // view_item_list: grade da coleção/busca (até 12 itens visíveis), no load e a cada filtro/página (cr:facets:updated);
  // L13a: sem as sugestões da gaveta/folha, que têm o envio próprio (sugestoesVistas) e não podem levar o nome da grade
  const listar = (soNovos) => {
    const cards = [...document.querySelectorAll('[data-cr-lista]:not(.cr-sugestoes__lista) [data-cr-item]')].filter((c) => !soNovos || !c.__crVisto);
    if (!cards.length) return;
    const lista = cards[0].closest('[data-cr-lista]').dataset.crLista;
    const items = [];
    cards.forEach((c) => { c.__crVisto = true; if (items.length < 12) { try { const it = JSON.parse(c.dataset.crItem); items.push(ga4Item(normItem(it), it.index)); } catch (e) {} } });
    event('view_item_list', { item_list_name: lista }, { item_list_name: lista, items });
  };
  if (ctx.template === 'collection' || ctx.template === 'search') {
    listar(false);
    document.addEventListener('cr:facets:updated', (e) => listar(e.detail && e.detail.acumular));
  }

  // InitiateCheckout: as portas do legado continuam (seletor + wrapper do ymp_getUrlWithUtms)
  document.addEventListener('click', (e) => { const b = e.target.closest && e.target.closest(CHECKOUT_SEL); if (b) beginCheckout(null, { alvo: b }); }, true);
  const orig = window.ymp_getUrlWithUtms;
  if (orig) window.ymp_getUrlWithUtms = function (url) { try { beginCheckout(); } catch (e) {} return orig(url); };

  // select_item por delegação: cards com data-cr-item dentro de [data-cr-lista]
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('[data-cr-item] a[href*="/products/"]');
    if (!a) return;
    const card = a.closest('[data-cr-item]');
    try { const it = JSON.parse(card.dataset.crItem); selectItem(it, { lista: card.closest('[data-cr-lista]')?.dataset.crLista || ctx.lista, index: it.index }); } catch (err) {}
  });

  // exp_view: bloco marcado que aparece na tela (atual ou inserido depois, ex.: drawer) e evento de estado
  const EXP_SEL = '[data-cr-exp][data-cr-braco]';
  const expDe = (el) => expView(el.dataset.crExp, el.dataset.crBraco);
  const io = window.IntersectionObserver ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); expDe(e.target); } })) : null;
  const vigiar = (el) => { if (el.__crExp) return; el.__crExp = true; if (io) io.observe(el); else expDe(el); };
  document.querySelectorAll(EXP_SEL).forEach(vigiar);
  document.addEventListener('cr:exp', (e) => { const { teste, braco, ...extras } = (e && e.detail) || {}; expView(teste, braco, extras); });
  seguro(promocoes)();

  // L13a: trio_step (folha do Monte seu trio) e view_item_list das sugestões da gaveta e da folha
  document.addEventListener('cr:kit:passo', (e) => seguro(trioPasso)(e && e.detail));
  const vigiarSug = seguro(sugestoesVistas)();

  // captura de usuário (legado): inputs atuais e futuros
  document.querySelectorAll('input, textarea').forEach(bindInput);
  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => {
    if (n.nodeType !== 1) return;
    (n.shadowRoot || n).querySelectorAll('input, textarea').forEach(bindInput);
    if (n.matches && n.matches(EXP_SEL)) vigiar(n);
    n.querySelectorAll(EXP_SEL).forEach(vigiar);
    if (vigiarSug) { if (n.matches && n.matches(SUG_SEL)) vigiarSug(n); n.querySelectorAll(SUG_SEL).forEach(vigiarSug); }
  }))).observe(document.body, { childList: true, subtree: true });
}

window.CR = window.CR || {};
window.CR.analytics = { addToCart: seguro(addToCart), cartChange: seguro(cartChange), viewCart: seguro(viewCart), beginCheckout: seguro(beginCheckout), selectItem: seguro(selectItem), expView: seguro(expView), event: seguro(event), eventId, envio: ENVIO };
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar, { once: true }); else iniciar();
